import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  formContainer: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-width: 0px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
